import type { TableData } from '../../../DataProvider/types';
import {
  getTableDimensionValue,
  getTableValue,
} from '../../../DataProvider/utils/table-data';
import { dimensionOfLevel } from '../../../DataResolver/taxonomy-levels';
import type { TableColumnConfig } from '../../../PageConfigProvider/types/item';
import type { CustomTableRow } from './convert-by-metric-to-table-rows';

export const getTableColumnRowKeys = (
  columns: readonly TableColumnConfig[],
  table: TableData | undefined
): string[] => {
  const seen = new Map<string, number>();
  return columns.map((column) => {
    if (column.kind === 'variable') return column.metric;
    const index = seen.get(column.dimension) ?? 0;
    seen.set(column.dimension, index + 1);
    const levels = (table?.dimensions ?? []).filter(
      (dimension) => dimensionOfLevel(dimension) === column.dimension
    );
    return levels[index] ?? column.dimension;
  });
};

export const convertTableDataToTableRows = (
  table: TableData
): CustomTableRow[] =>
  Array.from({ length: table.rowCount }, (_, row) => row)
    .filter((row) =>
      table.dimensions.every(
        (dimension) =>
          getTableDimensionValue(table, dimension, row) !== undefined
      )
    )
    .map((row) => {
      const tableRow: CustomTableRow = {};
      for (const dimension of table.dimensions) {
        tableRow[dimension] =
          getTableDimensionValue(table, dimension, row)?.label ?? null;
      }
      for (const metric of table.metrics) {
        tableRow[metric] = getTableValue(table, metric, row);
      }
      return tableRow;
    });
